import {ReactComponent as MoreIcon} from "../../../core/ui/icon/More.svg";

import "./_swap-price-details.scss";

import {
  getAssetInFromSwapQuote,
  getAssetOutFromSwapQuote
} from "@tinymanorg/tinyman-js-sdk";
import {Fragment, useState} from "react";
import classNames from "classnames";

import Button from "../../../component/button/Button";
import Spinner from "../../../component/spinner/Spinner";
import Typography from "../../../component/typography/Typography";
import {AsyncProcessState} from "../../../core/network/async-process/asyncProcessTypes";
import PoolPriceInfo from "../../../pool/price-info/PoolPriceInfo";
import {useSwapFormState} from "../context/SwapFormContext";
import SwapDetailsModal from "../details-modal/SwapDetailsModal";

interface SwapPriceDetailsProps {
  asyncProcessState: AsyncProcessState;
}

function SwapPriceDetails({asyncProcessState}: SwapPriceDetailsProps) {
  const state = useSwapFormState();

  const {isRequestPending} = asyncProcessState;
  const {quote} = state;

  const assetIn = state.assetIn.asset;
  const assetOut = state.assetOut.asset;

  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  return <div className={"swap-price-details"}>{renderContent()}</div>;

  function renderContent() {
    let content = <Fragment />;

    if (assetIn && assetOut) {
      if (isRequestPending && !isDetailsModalOpen) {
        content = (
          <div className={"is-vertically-centered swap-price-details__loading"}>
            <Spinner customClassName={"swap-price-details__loading-spinner"} />

            <Typography
              variant={"body"}
              textColor={"text-gray-lighter"}
              fontWeight={"medium"}
              as={"span"}
              customClassName={"swap-price-details__loading-text"}>
              {"Fetching the best price"}
            </Typography>
          </div>
        );
      } else if (quote) {
        content = (
          <div
            className={classNames(
              "is-vertically-centered",
              "has-space-between",
              "swap-price-details__success"
            )}>
            <PoolPriceInfo
              customClassName={"swap-price-details__price-info-button"}
              asset_1={assetIn}
              asset_1_reserves={Number(getAssetInFromSwapQuote(quote).amount)}
              asset_2={assetOut}
              asset_2_reserves={Number(getAssetOutFromSwapQuote(quote).amount)}
            />

            <Button
              onClick={openSwapPriceDetailsModal}
              typography={"body"}
              customClassName={classNames(
                "is-medium-text",
                "is-vertically-centered",
                "swap-price-details__view-details-button"
              )}
              size={"small"}>
              {"View details"}

              <MoreIcon />
            </Button>

            {isDetailsModalOpen && (
              <SwapDetailsModal
                asyncProcessState={asyncProcessState}
                isOpen={true}
                onClose={closeSwapPriceDetailsModal}
              />
            )}
          </div>
        );
      }
    }

    return content;
  }

  function closeSwapPriceDetailsModal() {
    setIsDetailsModalOpen(false);
  }

  function openSwapPriceDetailsModal() {
    setIsDetailsModalOpen(true);
  }
}

export default SwapPriceDetails;
